<template>
  <div class="listManager-btnGroup-wrap">
    <div class="listManager-btnGroup-left">
      <slot name="left"></slot>
    </div>
    <div class="listManager-btnGroup">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {},
  created () {
  },
  mounted () {
  }
}
</script>

<style scoped>

</style>
